// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -830047322
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { FacilitySummary } from './models/nonentity/facilitysummary';
import { ProviderSummary } from './models/nonentity/providersummary';
import { ProcedureSummary } from './models/nonentity/proceduresummary';
import { ContractSummary } from './models/nonentity/contractsummary';
import { AnesthesiaSummary } from './models/nonentity/anesthesiasummary';
import { Contact } from './models/facility/contact';
import { Document } from './models/facility/document';
import { BlobResult } from './models/common/blobresult';
import { UploadObject } from '../shared/models/uploadobject';
import { Facility } from './models/facility/facility';

export interface getFilteredFacilities_Filter {
  name: string;
  statusId: number;
  metroAreaId: number;
  stateId: number;
  isActive: boolean;
}

export interface getProvidersByFacilityId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getProceduresByFacilityId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getContractsByFacilityId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getAnesthesiasByFacilityId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getFacilityById_Filter {
  includeChildren: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FacilitiesApiService {
  constructor(protected http: HttpClient) {}

  getFilteredFacilities(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getFilteredFacilities_Filter>
  ): Observable<SmartListResult<FacilitySummary>> {
    let url = environment.chiliSauceApiRoot + `/api/Facilities/filtered`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<FacilitySummary>>(url, {
      params: params,
    });
  }

  getProvidersByFacilityId(
    facilityGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getProvidersByFacilityId_Filter>
  ): Observable<SmartListResult<ProviderSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/${facilityGuid}/providers`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ProviderSummary>>(url, {
      params: params,
    });
  }

  updateProvidersForFacilityId(
    facilityGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/${facilityGuid}/providers`;
    return this.http.put<any>(url, ids);
  }

  getProceduresByFacilityId(
    facilityGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getProceduresByFacilityId_Filter>
  ): Observable<SmartListResult<ProcedureSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/${facilityGuid}/procedures`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ProcedureSummary>>(url, {
      params: params,
    });
  }

  updateProceduresForFacilityId(
    facilityGuid: string,
    ids: number[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/${facilityGuid}/procedures`;
    return this.http.put<any>(url, ids);
  }

  getContractsByFacilityId(
    facilityGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getContractsByFacilityId_Filter>
  ): Observable<SmartListResult<ContractSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/${facilityGuid}/contracts`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ContractSummary>>(url, {
      params: params,
    });
  }

  updateContractsForFacilityId(
    facilityGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/${facilityGuid}/contracts`;
    return this.http.put<any>(url, ids);
  }

  getAnesthesiasByFacilityId(
    facilityGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getAnesthesiasByFacilityId_Filter>
  ): Observable<SmartListResult<AnesthesiaSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/${facilityGuid}/anesthesias`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<AnesthesiaSummary>>(url, {
      params: params,
    });
  }

  updateAnesthesiasForFacilityId(
    facilityGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/${facilityGuid}/anesthesias`;
    return this.http.put<any>(url, ids);
  }

  getContactsByFacilityId(facilityGuid: string): Observable<Contact[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/${facilityGuid}/contacts`;
    return this.http.get<Contact[]>(url);
  }

  updateContactsForFacilityId(
    facilityGuid: string,
    contacts: Contact[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/${facilityGuid}/contacts`;
    return this.http.put<any>(url, contacts);
  }

  getDocumentsByFacilityId(facilityGuid: string): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/${facilityGuid}/documents`;
    return this.http.get<Document[]>(url);
  }

  addFacilityDocuments(
    facilityGuid: string,
    documents: Document[]
  ): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/${facilityGuid}/documents`;
    return this.http.post<Document[]>(url, documents);
  }

  getDocumentsByProviderId(providerId: string): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Facilities/provider/${providerId}/documents`;
    return this.http.get<Document[]>(url);
  }

  uploadDocument(upload: UploadObject, metadata: any): Subject<void> {
    const url = environment.chiliSauceApiRoot + `/api/Facilities/upload`;

    if (!upload.file) {
      console.warn('no file specified to upload');
      return;
    }

    const subject = new Subject<void>();
    const fileToUpload = upload.file;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    let headers: HttpHeaders = null;
    if (metadata) {
      headers = new HttpHeaders({
        UploadMetadata: JSON.stringify(metadata),
      });
    }

    this.http
      .post(url, formData, {
        reportProgress: true,
        observe: 'events',
        headers: headers,
      })
      .subscribe((event) => {
        if (event.type === HttpEventType.UploadProgress) {
          upload.progress = Math.round((100 * event.loaded) / event.total);
        } else if (event.type === HttpEventType.Response) {
          const response = <BlobResult>event.body;
          upload.url = response.blobAddress;
          subject.next();
          subject.complete();
        }
      });

    return subject;
  }

  getAllFacilities(
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Facility>> {
    let url = environment.chiliSauceApiRoot + `/api/Facilities`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Facility>>(url);
  }

  addFacility(newFacility: Facility): Observable<Facility> {
    const url = environment.chiliSauceApiRoot + `/api/Facilities`;
    return this.http.post<Facility>(url, newFacility);
  }

  getFacilityById(
    facilityGuid: string,
    queryParams?: Partial<getFacilityById_Filter>
  ): Observable<Facility> {
    const url =
      environment.chiliSauceApiRoot + `/api/Facilities/${facilityGuid}`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<Facility>(url, { params: params });
  }

  updateFacility(facility: Facility, facilityGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Facilities/${facilityGuid}`;
    return this.http.put<any>(url, facility);
  }

  deleteFacility(facilityGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Facilities/${facilityGuid}`;
    return this.http.delete(url);
  }
}
